import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { ModalComponent } from '../../../../config/core.modal-helpers';
import { ProjectService } from '../../../../services/project.service';
import { ProjectSprintData } from '../../services/project.sprint.data.service';
import { UiService } from '../../../../services/core.ui.service';
import { GfTranslateService } from '../../../../services/core.translate.service';

import * as _ from 'lodash';

@Component({
	selector: 'project-sprint-delete',
	template: require('./project.sprint.delete.html'),
})
export class ProjectSprintDeleteComponent extends ModalComponent implements OnInit {

	@Input() sprint: any = null;
	@Input() project: any = null;

	@Input() legacyCallback: any = null;

	@Output() callback = new EventEmitter<any>();

	protected sprintTitle: string = '';

	constructor(
		private projectService: ProjectService,
		private uiService: UiService,
		private gfTranslateService: GfTranslateService,
	) {
		super();
	}

	ngOnInit() {
		if (this.sprint) {
			this.sprintTitle = this.getTitle(this.sprint);
		}
	};

	getTitle(sprint) {
		if (!sprint) return '';

		if (!_.isEmpty(_.get(sprint, 'sprintName', ''))) {
			return sprint.sprintName;
		}

		return this.gfTranslateService.translate('Sprint') + ' ' + _.get(sprint, 'sprintProgression', 1);
	}

	deleteSprint() {
		var ret = false;
		this.sprint.project = this.project.id;
		this.projectService.deleteSprint(this.sprint.id)
		.then(() => {
			this.uiService.message.showSuccess(this.gfTranslateService.translate('The sprint has been succesfuly deleted.'), this.sprintTitle);
			ret = true;
		})
		.catch(() => {
			var msg =  this.gfTranslateService.translate('There was a problem deleting the sprint');
			this.uiService.message.showWarning(msg, 'Data Error');
		})
		.finally(() => {
			this.legacyCallback && this.legacyCallback(this.sprint, ret);
			this.callback.emit(this.sprint);
			this.closeModal(ret);
		});
	};
}
